import React, { useContext, useEffect, useMemo, useState } from 'react'
import { SearchContext } from '../../contexts/searchContext'
import { ResponsiveContext } from '../../contexts/responsiveContext'
import styles from './styles.module.css'
import SearchResultVersionGroup from './SearchResultVersionGroup'
import SearchResultItem from './SearchResultItem'
import SearchEmptyState from './SearchEmptyState'

const SearchResult = () => {
  const [isActive, setIsActive] = useState(false)
  const { isSearchMobileActive, isVisible, query, result } = useContext(SearchContext)
  const { isMobile } = useContext(ResponsiveContext)
  const isNoResult = useMemo(() => isVisible && !result.length, [isVisible, result])

  useEffect(() => {
    if (isMobile) {
      setIsActive(isVisible && isSearchMobileActive)
    } else {
      setIsActive(isVisible)
    }
  }, [isMobile, isVisible, isSearchMobileActive])

  return (
    <div className={`${styles.searchResult} ${isActive && styles.active}`}>
      <ul>
        {result.map(({ category, versions }, index) => {
          return (
            <SearchResultItem title={category} key={index}>
              <SearchResultVersionGroup versions={versions} />
            </SearchResultItem>
          )
        })}
      </ul>

      {isNoResult && <SearchEmptyState query={query} />}
    </div>
  )
}

export default SearchResult
